import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import './index.css';

// Stale-deploy self-heal (2026-07-21). Routes are code-split; every
// rebuild renames the hashed chunks. A tab opened BEFORE a deploy that
// lazy-loads a route AFTER it requests a chunk that no longer exists
// (404) and the page silently never loads — "chart not loading" while
// already-visited pages still work. Vite surfaces that as
// `vite:preloadError`; reload once to pick up the fresh index.html
// (served no-store). The sessionStorage stamp stops a reload loop if
// something is genuinely broken.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const KEY = 'chunk-reload-at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last > 10_000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
